/** Short card/grid label when set; otherwise fall back to full product name. */
export const getProductDisplayName = (product) =>
  product?.displayName && product.displayName !== false
    ? product.displayName
    : product?.name ?? '';
